export default __webpack_public_path__ + "static/media/action-cam-1.95578837.png";